import { Controller } from "@hotwired/stimulus"

// Cycles through pre-rendered country slides in the World Traveller story
// with a shrink-to-center / expand-from-center animation
export default class extends Controller {
  static targets = ["slide"]
  static values = {
    interval: { type: Number, default: 3500 }
  }

  connect() {
    this.currentIndex = 0
    this.isTransitioning = false

    // Initialize all slides to proper state
    this.slideTargets.forEach((slide, index) => {
      const frame = slide.querySelector(".product-frame-container")
      const texts = slide.querySelectorAll(".carousel-text")

      if (index === 0) {
        // First slide is visible and at normal scale
        slide.classList.remove("hidden")
        if (frame) frame.style.transform = "scale(1)"
        texts.forEach(text => { text.style.transform = "scale(1)" })
      } else {
        // Other slides are hidden and scaled to 0
        slide.classList.add("hidden")
        if (frame) frame.style.transform = "scale(0)"
        texts.forEach(text => { text.style.transform = "scale(0)" })
      }
    })

    // Start cycling after a short delay if there are multiple slides
    if (this.slideTargets.length > 1) {
      this.startCycling()
    }
  }

  disconnect() {
    this.stopCycling()
  }

  startCycling() {
    this.cycleInterval = setInterval(() => {
      this.nextSlide()
    }, this.intervalValue)
  }

  stopCycling() {
    if (this.cycleInterval) {
      clearInterval(this.cycleInterval)
    }
  }

  nextSlide() {
    if (this.isTransitioning || this.slideTargets.length <= 1) return

    this.isTransitioning = true

    const currentSlide = this.slideTargets[this.currentIndex]
    const productFrame = currentSlide.querySelector(".product-frame-container")
    const carouselTexts = currentSlide.querySelectorAll(".carousel-text")

    // Shrink current content to center
    if (productFrame) productFrame.style.transform = "scale(0)"
    carouselTexts.forEach(text => { text.style.transform = "scale(0)" })

    // After shrink animation completes, switch slides
    setTimeout(() => {
      // Hide current slide
      currentSlide.classList.add("hidden")

      // Move to next slide
      this.currentIndex = (this.currentIndex + 1) % this.slideTargets.length
      const nextSlide = this.slideTargets[this.currentIndex]
      const nextProductFrame = nextSlide.querySelector(".product-frame-container")
      const nextCarouselTexts = nextSlide.querySelectorAll(".carousel-text")

      // Ensure next slide starts at scale 0
      if (nextProductFrame) nextProductFrame.style.transform = "scale(0)"
      nextCarouselTexts.forEach(text => { text.style.transform = "scale(0)" })

      // Show next slide
      nextSlide.classList.remove("hidden")

      // Force reflow before expanding
      void nextSlide.offsetHeight

      // Expand next slide content
      if (nextProductFrame) nextProductFrame.style.transform = "scale(1)"
      nextCarouselTexts.forEach(text => { text.style.transform = "scale(1)" })

      // Mark transition complete after expand animation
      setTimeout(() => {
        this.isTransitioning = false
      }, 350)
    }, 300)
  }
}
